<template>
  <div class="select-options" :class="{isOpenControlMenu}" :style="{...position}" v-click-outside="onCloseOption" @click.stop="() => {}">
    <div class="select-header">{{title}}</div>
    <div v-if="type === 'radio'" class="select-body">
      <div v-for="item in list" :key="item.value">
        <label class="select-item" @click="onChangedOption">
          <input type="radio" :name="`grm-select-${name}`" :checked="value == item.value" :value="item.value"/>
          <div>
            <div>{{item.name}}</div>
            <div v-if="item.message" class="item-message">{{item.message}}</div>
          </div>
        </label>
      </div>
    </div>
    <div v-if="type === 'checkbox'" class="select-body">
      <div v-for="(item, idx) in list" :key="item.value || idx">
        <label class="select-item" @click="onChangedOption">
          <input type="checkbox" :name="`grm-select-${name}`" :checked="checkboxValue[idx]" :value="idx" />
          <div>
            <div>{{item.name}}</div>
            <div v-if="item.message" class="item-message">{{item.message}}</div>
          </div>
        </label>
      </div>
    </div>
    <slot></slot>
    <div class="select-footer">
      <button class="select-footer-button select-cancel" @click="onCloseOption">{{button[0] || $t('common.cancel')}}</button>
      <button class="select-footer-button select-save" @click="onNextAct">{{button[1] || $t('common.confirm')}}</button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'GrmCamstudyOptionModal',
  data(){
    return {
      selectedValue: this.value,
    }
  },
  props: {
    position: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: {
      type: String,
      default: 'radio',
    },
    name: {
      type: String,
      default: '',
    },
    css: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Array],
      default: '',
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: '',
    },
    button: {
      type: Array,
      default: () => {
        return [null, null]
      }
    }
  },
  computed: {
    ...mapGetters('common', ['isOpenControlMenu']),
    checkboxValue() {
      return Array.isArray(this.value) ? [...this.value] : [];
    },
  },
  methods: {
    onNextAct(){
      this.$emit('onNextAct', this.type === 'radio' ? this.selectedValue : this.checkboxValue)
    },
    onCloseOption(){
      this.$emit('onCloseOption')
    },
    onChangedOption(e){
      if(this.type === 'radio') {
        if (!e.target.value) {
          return;
        }
        this.selectedValue = e.target.value;
      } else if(this.type === 'checkbox') {
        this.checkboxValue[e.target.value] = !this.checkboxValue[e.target.value];
      }
    },
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  .select-options{
    @media(orientation: portrait){
      bottom: 8px !important;
      width: calc(100vw - 16px);
      .select-body{
        max-height: 300px;
      }
      left: 8px;
    }
    @media(orientation: landscape){
      bottom: 34px !important;
      &.isOpenControlMenu{
        bottom: 8px !important;
      }
      width: 360px;
      left: 50% !important;
      transform: translateX(-50%);
      .select-body{
        max-height: calc(100dvh - 68px - 181px);
      }
    }
  }
}
html:not([grm-device-mobile]) .select-options{
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 360px;
}
.select-options{
  position: fixed;
  max-height: calc(100vh - 68px);
  border-radius: 12px;
  background: #313131;
  color: #FFF;
  z-index: 999;
  overflow: hidden;
  padding-top: 6px;
  
  .select-header{
    width: 100%;
    text-align: center;
    height: 44px;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 1.5;
  }
  .select-body{
    width: 100%;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }

    .select-item{
      display: flex;
      align-items: center;
      width: 100%;      
      padding: 12px 20px;
      gap: 12px;

      input[type=radio]{
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 22px;
        height: 22px;
        border-radius: 100%;
        border: 2px solid rgba(255, 255, 255, 0.1);
        // background: url('~@/assets/images/camstudy/ico_option_radio_not_checked.svg') no-repeat center center;
        
        &:checked{
          border: 7px solid #016FF2;
        }
      }
      input[type=checkbox]{
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        outline: none;
        cursor: pointer;
        background: url('~@/assets/images/camstudy/ico_radio_not_checked.svg') no-repeat;
      }
      input[type=checkbox]:checked {
        background: url('~@/assets/images/camstudy/ico_radio_checked.svg') no-repeat;
      }
    }
    .item-message{
      margin-top: 4px;
      color: #999;
      font-size: 11px;
    }
  }
  .select-footer{
    width: 100%;
    display: flex;
    padding-top: 12px;
    .select-footer-button{
      width: 100%;
      display: flex;
      padding: 15px 0 14px;
      justify-content: center;
      align-items: center;
      border-top: 0.333px solid rgba(255, 255, 255, 0.20);

      &.select-cancel{
        color: #999;
        font-size: 14px;
        line-height: 150%;
      }
      &.select-save{
        color: #FFF;
        font-size: 14px;
        font-weight: 700;
        line-height: 150%;
      }
    }
  }
}
</style>